import axios from 'axios'
import { TokenService } from './storage.service'
import { store } from '../store'

const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = `${TokenService.getToken()}`
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) {
        return axios.get(resource)
    },

    _get(resource,data = {}) {
        return axios.get(resource,{params: data})
    },

    post(resource, data) {
        return axios.post(resource, data)
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        return axios(data)
    },

    _401interceptor: null,

    mount401Interceptor() {

        this._401interceptor = axios.interceptors.response.use(
            (response) => {
                return response
            },
            async (error) => {


                if (error.request.status == 401) {

                    /**
                    * Custom error para reconocer error cuando el link de recuperar contraseña expiró,
                    * en ese caso se muestra error al usuario, en cualquier otro es logout de la plataforma
                    **/
                    var message = JSON.parse(error.request.response);
                    if (message.status == "error-reset-pwd-expired-token"){
                      throw error;
                    }else{
                      store.dispatch('auth/logout')
                      throw error;
                    }

                    /**
                    * TODO implementar refresh token
                    **/

                    // if (error.config.url.includes('/o/token/')) {
                    //     // Refresh token has failed. Logout the user
                    //     store.dispatch('auth/logout')
                    //     throw error
                    // } else {
                    //     // Refresh the access token
                    //     try{
                    //         await store.dispatch('auth/refreshToken')
                    //         // Retry the original request
                    //         return this.customRequest({
                    //             method: error.config.method,
                    //             url: error.config.url,
                    //             data: error.config.data
                    //         })
                    //     } catch (e) {
                    //         // Refresh has failed - reject the original request
                    //         throw error
                    //     }
                    // }
                }

                // If error was not 401 just reject as is
                throw error
            }
        )
    }
}

export default ApiService
